export enum TypeMapMarker {
    PROVIDER_ACTIVE_ADDRESS = 'PROVIDER_ACTIVE_ADDRESS',
    PROVIDER_ACTIVE_ZONE = 'PROVIDER_ACTIVE_ZONE',
    PROVIDER_INACTIVE_ADDRESS = 'PROVIDER_INACTIVE_ADDRESS',
    PROVIDER_INACTIVE_ZONE = 'PROVIDER_INACTIVE_ZONE',
    PROVIDER_INACTIVE_CANCELLED_ADDRESS = 'PROVIDER_INACTIVE_CANCELLED_ADDRESS',
    PROVIDER_INACTIVE_CANCELLED_ZONE = 'PROVIDER_INACTIVE_CANCELLED_ZONE',
    PROVIDER_INACTIVE_POSSIBLE_ADDRESS = 'PROVIDER_INACTIVE_POSSIBLE_ADDRESS',
    PROVIDER_INACTIVE_POSSIBLE_ZONE = 'PROVIDER_INACTIVE_POSSIBLE_ZONE',
    PATIENT_ACTIVE = 'PATIENT_ACTIVE',
    PATIENT_INACTIVE= 'PATIENT_INACTIVE',
    GENERAL = 'GENERAL',
    CASE = 'CASE',
    CLUSTER= 'CLUSTER'
}
